import * as _ContextMenu from '@radix-ui/react-context-menu'
import { TLPageId, useApp, useContainer } from '@tldraw/editor'
import { track } from 'signia-react'
import { Button } from '../primitives'

export const MoveToPageMenu = track(function MoveToPageMenu() {
	const app = useApp()
	const container = useContainer()
	const pages = app.pages
	const currentPageId = app.currentPageId

	return (
		<_ContextMenu.Sub>
			<_ContextMenu.SubTrigger dir="ltr" asChild>
				<Button
					className="tlui-menu__button"
					label="context-menu.move-to-page"
					data-wd="menu-item.move-to-page"
					icon="chevron-right"
				/>
			</_ContextMenu.SubTrigger>
			<_ContextMenu.Portal container={container} dir="ltr">
				<_ContextMenu.SubContent className="tlui-menu" sideOffset={-4} collisionPadding={4}>
					{pages.map((page) => (
						<_ContextMenu.Item
							key={page.id}
							disabled={currentPageId === page.id}
							onSelect={() => {
								app.mark('move_shapes_to_page')
								app.moveShapesToPage(app.selectedIds, page.id as TLPageId)
							}}
							asChild
						>
							<Button
								title={page.name}
								className="tlui-menu__button tlui-context-menu__move-to-page__name"
							>
								<span>{page.name}</span>
							</Button>
						</_ContextMenu.Item>
					))}
				</_ContextMenu.SubContent>
			</_ContextMenu.Portal>
		</_ContextMenu.Sub>
	)
})
